import { RouteType } from "types/RouteType";
// import designValuesRoute from "./DesignValues/designValues.Route";
// UNREGISTERED 2026-08-18. /job/:jobNumber/quality-control served 50 fabricated
// rows straight out of testData.json — its store's `entities` getter returns the
// fixture unconditionally and the fetch branch is commented out — and the route
// was declared `requiresAuth: false`, so anyone could reach fake QC data without
// signing in. It also points at `qcServiceStore`, which is registered nowhere,
// so its fetch/update methods would throw if they ever ran.
//
// Unregistered rather than deleted: the per-job QC view may be worth rebuilding
// on the hub's project filter, and the components are the starting point. Do not
// re-register it without wiring a real service first.
// import qualityControlRoute from "./QualityControl/qualityControl.Route";
// import qualityControlOverviewRoute from "./QualityControlOverview/qualityControlOverview.Route";
import qualityControlHubRoute from "./QualityControlHub/qualityControlHub.Route";
// Sibling tab routes are now consolidated under qualityControlHubRoute and intentionally not registered:
// import todayDashboardRoute from "./TodayDashboard/todayDashboard.Route";
// import rejectionsQueueRoute from "./RejectionsQueue/rejectionsQueue.Route";
// import reschedulingQueueRoute from "./ReschedulingQueue/reschedulingQueue.Route";
// import inspectionExportRoute from "./InspectionExport/inspectionExport.Route";

const qualityControlRoutesList: RouteType[] = [
    // ...designValuesRoute,
    // qualityControlRoute,  // see the note above — fabricated data, unauthenticated
    // ...qualityControlOverviewRoute,
    qualityControlHubRoute,
];

export default qualityControlRoutesList;
